import { atom } from "kho";
import type { Camera, Object3D, WebGLRenderer } from "three";

/**
 * The imperative Viewer, published as an atom so kho editor systems can pull
 * what they need instead of the Viewer (via DesignManager) pushing it in every
 * frame. `viewerAdapterSystem` is the ONLY system that reads this — it feeds the
 * abstract bridge atoms ($camera / $renderer / $cloudScenes) — so the gizmo /
 * instance systems stay independent of the concrete EARTHBRAIN viewer.
 *
 * Minimal host surface (grows as DesignManager responsibilities migrate here).
 */
export interface ViewerHost {
  getCamera(): Camera | null;
  getRenderer(): WebGLRenderer | null;
  /** STREAM + STATIC point-cloud container scenes (surface picking targets). */
  getCloudScenes(): Object3D[];
  /** Adaptive near/far for the design scene (tall objects clipping), or null. */
  getDesignClip(camera: Camera): { near: number; far: number } | null;
  /** Notify the viewer a gizmo drag is active (locks camera orbit). */
  setDragActive(active: boolean): void;
}

export const $viewer = atom<ViewerHost | null>(null);
